import React, { useEffect } from 'react';
import { useRegisterComponent } from '../../../orchestrator';
import { useCreateAccountConfirmationPageContext } from '../contexts/CreateAccountConfirmationPageContext';
import MarketingConsent from '../../../../components/MarketingConsentCheckbox';
import { RootState, useAppDispatch, useAppSelector } from '../../../../stores/redux.store';
import { fetchConsentConfig } from '../../../../actions/marketing-consent-actions';

const marketingConsentSelector = (state: RootState) => state.marketingConsent.config;
const createAccountEmailSelector = (state: RootState) => state.createAccount.email;

export const CreateAccountConfirmationMarketingConsent = () => {
  useRegisterComponent(CreateAccountConfirmationMarketingConsent.name);

  const dispatch = useAppDispatch();

  const { setMarketingConsent } = useCreateAccountConfirmationPageContext();
  const marketingConsentConfig = useAppSelector(marketingConsentSelector);
  const email = useAppSelector(createAccountEmailSelector);

  useEffect(() => {
    if (email) {
      dispatch(fetchConsentConfig(email));
    }
  }, [dispatch, email]);

  return <MarketingConsent config={marketingConsentConfig} onConsentChange={setMarketingConsent} />;
};
